import Swiper, { Navigation, Autoplay } from 'swiper';
const sliders = () => {
	const sponsors = new Swiper('.banner-swiper', {
		modules: [Autoplay, Navigation],
		slidesPerView: 1,
		spaceBetween: 40,
		speed: 600,
		loop: true,
		navigation: {
			nextEl: '.sponsors .swiper-next',
			prevEl: '.sponsors .swiper-prev'
		},
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true
		}
	});

	const sliders = document.querySelectorAll('.main-swiper');

	sliders &&
		sliders.forEach((slider) => {
			const $sliderArgs = {
				modules: [Navigation],
				slidesPerView: 1.25,
				spaceBetween: 20,
				speed: 600,
				navigation: {
					nextEl: '.title-with-slider .swiper-next',
					prevEl: '.title-with-slider .swiper-prev'
				},
				breakpoints: {
					768: {
						slidesPerView: 2.25,
						spaceBetween: 40
					},
					1024: {
						slidesPerView: 2.75,
						spaceBetween: 40
					},
					1400: {
						slidesPerView: 3.5,
						spaceBetween: 40
					}
				}
			};

			if (slider.classList.contains('gallery-swiper')) {
				$sliderArgs.breakpoints = {
					768: {
						slidesPerView: 2.6
					},
					1024: {
						slidesPerView: 3.2
					}
				};
			}

			const mainSlider = new Swiper(slider, $sliderArgs);
		});
};

export default sliders;
